<template>
    <ListModule
        :label="$t('components.smart.featuredCompanies.label')"
        :data="data"
        :to="companyURL()"
        :isLoading="loading()"
    />
</template>

<script>
export default {
    name: 'FeaturedCompanies',
    data() {
        return {
            doublePromotion: {
                159: true,
                313: true,
                240: true,
                464: true,
                1260: true,
                172: true,
                381: true,
                1249: true,
                396: true,
                293: true,
                445: true,
                1921: true,
                124: true,
                1972: true,
                183: true,
            },
            singlePromotion: {
                387: true,
                309: true,
                326: true,
                1247: true,
                401: true,
                279: true,
            },
        };
    },
    computed: {
        featuredPostings() {
            return this.$interfaces.company.get({
                reactive: true,
            });
        },
        data() {
            let data = this.featuredPostings.data;
            if (!data) return [];
            return [
                ...data
                    .filter(it => this.doublePromotion[it.id])
                    .sort(() => 0.5 - Math.random())
                    .slice(0, 4),
                ...data
                    .filter(it => this.singlePromotion[it.id])
                    .sort(() => 0.5 - Math.random())
                    .slice(0, 1),
            ].map(value => ({
                id: value.id,
                header: value.name,
                subheader: ''.concat(
                    value.country || '',
                    value.country && value.location ? ', ' : '',
                    value.location || ''
                ),
                image: value.logo,
            }));
        },
    },
    methods: {
        loading() {
            return this.featuredPostings.loading;
        },
        error() {
            return this.featuredPostings.error;
        },
        companyURL: function() {
            return this.$URLS.findcompanies;
        },
    },
};
</script>

<style scoped></style>
